"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("./util/routes");
const react_modal_1 = __importDefault(require("react-modal"));
const container = document.getElementById("root");
const root = (0, client_1.createRoot)(container);
const router = (0, react_router_dom_1.createBrowserRouter)(routes_1.routes);
react_modal_1.default.setAppElement("#root");
root.render((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.RouterProvider, { router: router }) }));
